// extracted by mini-css-extract-plugin
module.exports = {"search__sort":"SearchSort_search__sort___kIOG"};